import { SVGProps, forwardRef, useMemo } from 'react';
import { cn } from '../../libs';

interface SpinnerProgressProps extends SVGProps<SVGSVGElement> {
  /**
   * The progress of the spinner progress.
   */
  progress: number;
  /**
   * The size of the spinner progress.
   */
  size?: number;
}

const getStrokeDashoffset = (progress: number) => {
  const radius = 6.5;
  const circumference = 2 * Math.PI * radius;
  return {
    radius,
    circumference,
    strokeDashoffset: circumference * (1 - progress / 100),
  };
};

/**
 * > Inherits the text color from the parent element.
 */
export const SpinnerProgress = forwardRef<SVGSVGElement, SpinnerProgressProps>(
  ({ size = 24, progress, ...rest }, ref) => {
    const { radius, circumference, strokeDashoffset } = useMemo(() => getStrokeDashoffset(progress), [progress]);

    return (
      <svg
        {...rest}
        ref={ref}
        className={cn(rest.className)}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r={radius} stroke="currentColor" strokeOpacity="0.1" strokeWidth="2" />
        <circle
          cx="9"
          cy="9"
          r={radius}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform="rotate(-90 9 9)"
        />
      </svg>
    );
  },
);
